module.exports = __webpack_public_path__ + "media/images/buttons/add-3e22d4a6b45fb1205063508ca8b3b774.png";